module.exports = __webpack_public_path__ + "img/02.ac8d2db7.png";